import styled from 'styled-components'

export default styled.p`
  color: ${({ theme, color }) =>
    theme.colors[color] || color || theme.colors.blueDark};
`
